import { render, staticRenderFns } from "./VacancyAiQuestionRow.vue?vue&type=template&id=2eea2b8e&scoped=true&"
import script from "./VacancyAiQuestionRow.vue?vue&type=script&lang=js&"
export * from "./VacancyAiQuestionRow.vue?vue&type=script&lang=js&"
import style0 from "./VacancyAiQuestionRow.vue?vue&type=style&index=0&id=2eea2b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea2b8e",
  null
  
)

/* custom blocks */
import block0 from "./VacancyAiQuestionRow.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyAiQuestionRow.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardActions,VIcon,VTextarea})
